import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { baseurImage, baseurl } from "../../../Baseurl";
import axios from "axios";
import { toast } from "react-toastify";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axiosInstance from "../../../api/axiosInstance";
import SignatureCanvas from "react-signature-canvas";

export default function EditDoctor() {
  const location = useLocation();
  const navigate = useNavigate();
  const doctor = location.state?.doctor;

  const [formData, setFormData] = useState({
    email: "",
    fullName: "",
    shortName: "",
    prefix: "",
    dateOfBirth: "",
    licenseId: "",
    civilId: "",
    passport: "",
    gender: "",
    specialty: "",
    phoneNumber: "",
    password: "",
  });
  const [files1, setFiles1] = useState(null);
  const [stampFile, setStampFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const sigCanvasRef = useRef(null);
  const [existingSignature, setExistingSignature] = useState(null);
  const [existingStamp, setExistingStamp] = useState(null);
  const [clearExistingSignature, setClearExistingSignature] = useState(false);

  useEffect(() => {
    if (doctor) {
      setFormData({
        email: doctor.email || "",
        fullName: doctor.fullName || "",
        shortName: doctor.shortName || "",
        prefix: doctor.prefix || "",
        dateOfBirth: doctor.dateOfBirth ? doctor.dateOfBirth.split('T')[0] : "",
        licenseId: doctor.licenseId || "",
        civilId: doctor.civilId || "",
        passport: doctor.passport || "",
        gender: doctor.gender || "",
        specialty: doctor.specialty || "",
        phoneNumber: doctor.phoneNumber || "",
      });
      if (doctor.signature) setExistingSignature(doctor.signature);
      if (doctor.stamp) setExistingStamp(doctor.stamp);
    }
  }, [doctor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFiles1(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formDataToSend = new FormData();

      // Add all form fields
      Object.keys(formData).forEach(key => {
        if (formData[key]) {
          formDataToSend.append(key, formData[key]);
        }
      });

      // Add file if selected
      if (files1) {
        formDataToSend.append("personalPhoto", files1);
      }
      if (stampFile) {
        formDataToSend.append("stamp", stampFile);
      }
      if (sigCanvasRef.current && !sigCanvasRef.current.isEmpty()) {
        formDataToSend.append("signature", sigCanvasRef.current.toDataURL("image/png"));
      } else if (clearExistingSignature) {
        formDataToSend.append("clearSignature", "true");
      }

      const response = await axiosInstance.put(`updateDoctorDetails/${doctor.id}`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        toast.success("Doctor updated successfully!");
        navigate("/Admin/ManageStaff");
      }
    } catch (error) {
      console.error("Error updating doctor:", error);
      toast.error("Failed to update doctor. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get doctor image URL
  const getDoctorImageUrl = (doctor) => {
    if (doctor.personalPhoto && doctor.personalPhoto !== "null" && doctor.personalPhoto !== "undefined") {
      return `${baseurImage}${doctor.personalPhoto}`;
    }
    return "../assets/images/user/avatar-2.jpg";
  };

  if (!doctor) {
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="col-12">
            <div className="card table-card">
              <div className="tableHeader">
                <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                    onClick={() => navigate(-1)}
                    title="Back"
                  >
                    &larr;
                  </span>
                  Edit Doctor
                </h5>
              </div>
              <div className="card-body text-center">
                <p>No doctor data available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <div className="d-flex">
                <ArrowBackIcon style={{ cursor: "pointer" }} onClick={() => navigate(-1)} /> <h5>Edit Doctor</h5>
              </div>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit} encType="multipart/form-data" className="row g-3 px-3 py-2 mb-3">
                {/* <div className="row justify-content-center mb-4">
                  <div className="col-md-4 text-center">
                    <img
                      src={getDoctorImageUrl(doctor)}
                      alt={doctor.fullName}
                      className="img-fluid rounded mb-3"
                      style={{ maxHeight: "200px", objectFit: "contain" }}
                      onError={(e) => {
                        e.target.src = "../assets/images/user/avatar-2.jpg";
                      }}
                    />
                    <div>
                      <input
                        type="file"
                        name="personalPhoto"
                        className="form-control"
                        onChange={handleFileChange}
                        accept="image/*"
                      />
                      <small className="text-muted">Upload new photo (optional)</small>
                    </div>
                  </div>
                </div> */}

                <div className="col-md-6">
                  <label className="form-label">Prefix</label>
                  <select
                    className="form-control"
                    name="prefix"
                    value={formData.prefix}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Dr.">Dr.</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Miss">Miss</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="First Name"
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="shortName"
                    value={formData.shortName}
                    onChange={handleChange}
                    placeholder="Last Name"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="doctor@gmail.com"
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Gender</label>
                  <select
                    className="form-control"
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Specialty</label>
                  <input
                    type="text"
                    className="form-control"
                    name="specialty"
                    value={formData.specialty}
                    onChange={handleChange}
                    placeholder="Orthopedic"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Date of Birth</label>
                  <input
                    type="date"
                    className="form-control"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">License ID</label>
                  <input
                    type="text"
                    className="form-control"
                    name="licenseId"
                    value={formData.licenseId}
                    onChange={handleChange}
                    placeholder="License Number"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Civil ID</label>
                  <input
                    type="text"
                    className="form-control"
                    name="civilId"
                    value={formData.civilId}
                    onChange={handleChange}
                    placeholder="Civil ID"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Passport</label>
                  <input
                    type="text"
                    className="form-control"
                    name="passport"
                    value={formData.passport}
                    onChange={handleChange}
                    placeholder="Passport Number"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    placeholder="+91 8859932237"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Photo</label>
                  <input
                    type="file"
                    name="personalPhoto"
                    className="form-control"
                    onChange={handleFileChange}
                    accept="image/*"
                  />
                </div>

                {/* Stamp Upload */}
                <div className="col-md-6">
                  <label className="form-label">
                    Stamp <span className="text-muted" style={{ fontSize: "11px" }}>(optional – PNG)</span>
                  </label>
                  {existingStamp && !stampFile && (
                    <div style={{ marginBottom: "6px" }}>
                      <img
                        src={existingStamp.startsWith("data:") ? existingStamp : `${baseurImage}${existingStamp}`}
                        alt="Current stamp"
                        style={{ maxHeight: "70px", border: "1px solid #dee2e6", borderRadius: "6px" }}
                      />
                      <div className="text-muted" style={{ fontSize: "11px" }}>Current stamp – upload new to replace</div>
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/png,image/jpeg,image/jpg"
                    className="form-control"
                    onChange={(e) => setStampFile(e.target.files[0] || null)}
                  />
                  {stampFile && (
                    <img
                      src={URL.createObjectURL(stampFile)}
                      alt="New stamp preview"
                      style={{ marginTop: "8px", maxHeight: "70px", border: "1px solid #dee2e6", borderRadius: "6px" }}
                    />
                  )}
                </div>

                {/* Signature Pad */}
                <div className="col-12">
                  <label className="form-label">
                    Signature <span className="text-muted" style={{ fontSize: "11px" }}>(optional – draw below to update)</span>
                  </label>
                  {existingSignature && !clearExistingSignature && (
                    <div style={{ marginBottom: "8px" }}>
                      <img
                        src={existingSignature.startsWith("data:") ? existingSignature : `${baseurImage}${existingSignature}`}
                        alt="Current signature"
                        style={{ maxHeight: "70px", border: "1px solid #dee2e6", borderRadius: "6px", background: "#fff", padding: "4px" }}
                      />
                      <div>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger mt-1"
                          onClick={() => setClearExistingSignature(true)}
                        >
                          Remove Signature
                        </button>
                      </div>
                    </div>
                  )}
                  {(!existingSignature || clearExistingSignature) && (
                    <>
                      <div style={{ border: "1px solid #dee2e6", borderRadius: "6px", display: "inline-block", background: "#fff" }}>
                        <SignatureCanvas
                          ref={sigCanvasRef}
                          penColor="#000"
                          canvasProps={{ width: 400, height: 120, style: { display: "block" } }}
                        />
                      </div>
                      <div>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary mt-1"
                          onClick={() => sigCanvasRef.current?.clear()}
                        >
                          Clear
                        </button>
                        {clearExistingSignature && (
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary mt-1 ms-2"
                            onClick={() => setClearExistingSignature(false)}
                          >
                            Keep Existing
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">Password (Leave blank to keep current)</label>
                  <div className="position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter new password"
                      autoComplete="new-password"
                    />
                    <i
                      className={`ti ${showPassword ? "ti-eye-off" : "ti-eye"}`}
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "18px",
                      }}
                    ></i>
                  </div>
                </div>

                <div className="col-12 mb-3 text-center">
                  <button type="submit" className="bgBtn" disabled={loading}>
                    {loading ? "Updating..." : "Update Doctor"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
